/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.scss'
import React from 'react'
import { togglePopup } from '../../../Redux/popups/popupSlice'
import popupList from './Popups/popupList'
import childrenPopupList from './Popups/childrenPopupList'

function PopupManager() {
  const dispatch = useDispatch()
  const { pointer, data, nested } = useSelector((state) => state.popups)
  const { customStyle } = data || {
    customStyle: {}
  }
  const closePopup = () => {
    dispatch(
      togglePopup({
        pointer: 0,
        data: null
      })
    )
  }
  if (pointer > 0) {
    // Custom style for AddNewWithdraw (pointer 9) and AddNewExpense (pointer 7)
    let customStyleToApply = { ...customStyle };
    if (pointer === 9 || pointer === 7) {
      customStyleToApply = {
        ...customStyleToApply,
        minWidth: '25%',
        maxWidth: '40%',
      };
    }
    return (
      <>
        <div className={styles.popup_overlay}>
          <div
            className={styles.popup_child_container}
            style={customStyleToApply}
          >
            {popupList({
              pointer,
              data,
              close: closePopup
            })}
          </div>
        </div>
        {nested.pointer && (
          <div className={styles.child_popup_overlay}>
            <div className={styles.popup_child_container}>{childrenPopupList({ nested })}</div>
          </div>
        )}
      </>
    )
  }
}
export default PopupManager
